<template>
  <div class="container event__content-container">
    <EventInfo class="event__content-card" :event-id="eventId" />
    <EventCalendar class="event__content-card" id="event-calendar" />
    <EventCompanyProfile
      id="event-company-profile"
      class="event__content-card"
    />
    <EventUsers id="event-users" class="event__content-card" />
    <div class="event__content-title">
      {{ $t("event.servicesTitle") }}
    </div>

    <EventServicesOrder
      v-if="isServiceShown"
      :event-id="eventId"
      id="event-services-order"
      class="event__content-card"
    />
    <EventCatalogPlacement
      v-if="!isUserRoleInstaller"
      id="event-catalog-placement"
      class="event__content-card"
    />
    <div v-if="!isUserRoleInstaller" class="event__content-title">
      {{ $t("event.documentsTitle") }}
    </div>
    <EventDocuments
      v-if="!isUserRoleInstaller"
      class="event__content-card"
      :event-id="eventId"
      id="event-documents"
    />
    <EventPasses
      v-if="!isUserRoleInstaller"
      :event-id="eventId"
      id="event-passes"
      class="event__content-card"
    />
  </div>
</template>
<script>
import EventInfo from "@/components/Custom/EventInfo.vue";
import EventCalendar from "@/components/Custom/EventCalendar.vue";
import { mapGetters } from "vuex";
import EventCompanyProfile from "@/components/Custom/EventCompanyProfile.vue";
import EventUsers from "@/components/Custom/EventUsers.vue";
import EventServicesOrder from "@/components/Custom/EventServicesOrder.vue";
import EventCatalogPlacement from "@/components/Custom/EventCatalogPlacement.vue";
import EventPasses from "@/components/Custom/EventPasses.vue";
import EventDocuments from "@/components/Custom/EventDocuments.vue";

export default {
  name: "ParticipantSelf",

  components: {
    EventDocuments,
    EventPasses,
    EventCatalogPlacement,
    EventServicesOrder,
    EventUsers,
    EventCompanyProfile,
    EventInfo,
    EventCalendar
  },
  computed: {
    ...mapGetters("event", ["eventId", "isServiceShown", "isUserRoleInstaller"])
  }
};
</script>
